import React, { useState, useEffect } from 'react';
import slide1 from '../../images/slide-1.jpg';
import slide2 from '../../images/slide-2.jpg';
import slide3 from '../../images/slide-3.jpg';
import { Network, AudioLines, Plus} from "lucide-react";

const carouselSlides = [
  {
    image: slide1,
    icon: (
        <Plus className="h-10 w-10 text-cyan-600" />
    ),
    title: "Create Rich Content",
    desc: "Build interactive learning modules with multimedia content, quizzes, and engaging activities."
  },
  {
    image: slide2,
    icon: (
      <Network className="h-10 w-10 text-cyan-600" />
    ),
    title: "Collaborate Easily",
    desc: "Invite team members and work together on projects in real time."
  },
  {
    image: slide3,
    icon: (
      <AudioLines className="h-10 w-10 text-cyan-600" />
    ),
    title: "Track Progress",
    desc: "Monitor learner progress and get actionable insights."
  }
];

const Carousel = () => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setCarouselIndex((prev) => (prev + 1) % carouselSlides.length);
    }, 5000);
    return () => clearTimeout(timer);
  }, [carouselIndex]);

  const slide = carouselSlides[carouselIndex];

  return (
    <div className="w-1/2 hidden lg:flex flex-col justify-center items-center relative bg-gradient-to-br from-cyan-400 to-cyan-600">
      <img src={slide.image} alt="Background" className="absolute inset-0 w-full h-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-cyan-900 bg-opacity-30"></div>
      <div className="relative z-10 flex flex-col items-center justify-center w-full h-full p-12 transition-all duration-500">
        <div className="mb-6">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-white bg-opacity-80">
            {slide.icon}
          </div>
        </div>
        <h2 className="text-3xl font-bold text-white mb-2">{slide.title}</h2>
        <p className="text-lg text-white mb-6">{slide.desc}</p>
        <div className="flex justify-center gap-3 mt-6">
          {carouselSlides.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to slide ${i + 1}`}
              onClick={() => setCarouselIndex(i)}
              className={`w-3 h-3 rounded-full transition-all duration-200 focus:outline-none ${i === carouselIndex ? 'bg-white shadow-lg' : 'bg-white bg-opacity-40'}`}
              style={i === carouselIndex ? { transform: 'scale(1.2)' } : {}}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
